module.exports = __webpack_public_path__ + "img/OutOfSearch.a38d3185.jpg";